import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-primary-contrast" data-id="element-44">
      <div className="max-w-4xl mx-auto" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-text-primary text-white rounded-3xl p-8 sm:p-12 text-center relative overflow-hidden shadow-2xl" data-id="element-46">
          {/* Decorative background */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-accent/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-47"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-health/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-48"></div>

          <div className="relative z-10 flex flex-col items-center" data-id="element-49">
            <div className="w-24 h-24 bg-accent rounded-full flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(212,163,115,0.5)]" data-id="element-50">
              <ShieldCheck size={48} className="text-white" data-id="element-51" />
            </div>

            <h2 className="text-3xl sm:text-4xl font-serif font-bold mb-6" data-id="element-52">
              Tienes 30 días para probarlo{' '}
              <span className="text-accent" data-id="element-53">sin riesgo</span>
            </h2>

            <p className="text-lg sm:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed mb-8" data-id="element-54">
              Estamos tan seguros de que este protocolo cambiará cómo te
              sientes, que asumimos todo el riesgo. Descarga el material, lee la
              guía, aplica los 4 pilares. Si en 30 días sientes que no fue útil
              para ti, solo envíanos un correo y te devolveremos cada centavo de
              tus $6.36. Sin preguntas incómodas.
            </p>

            <div className="inline-block border border-white/20 bg-white/5 backdrop-blur-sm px-6 py-3 rounded-full font-bold tracking-widest uppercase text-sm text-accent" data-id="element-55">
              Garantía de Satisfacción 100%
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}